// หน้ารายงานหนึ่งตัวจาก Discover
//
// สองแบบ: หน้าของ Inbox Center ที่มีคอมโพเนนต์ฝังอยู่แล้ว กับระบบนอกที่ฝังตรงไป
// โดเมนเขาเหมือน KOL Report (ไม่ผ่าน reverse proxy) — ระบบนอกอาจตั้ง
// X-Frame-Options ไว้จนฝังไม่ได้ ซึ่งเราตรวจจากในหน้าไม่ได้เลย จึงมีปุ่ม
// "เปิดในแท็บใหม่" คู่ไว้เสมอเป็นทางออก
import { Link, Navigate } from "react-router";
import type { Brand } from "@contracts/api";
import { EmbedHead } from "@features/embeds/components/embed-head";
import { FbEmbedPage } from "@features/embeds/pages/fb-embed-page";
import { menuPath } from "@features/navigation/model/side-menus";
import { blockedReason, findReport } from "../model/reports";

/** รายงานที่ย้ายออกไปอยู่เมนูอื่นแล้ว — ลิงก์/บุ๊กมาร์กเก่าต้องไปถึงที่ใหม่ ไม่ใช่ตาย */
const MOVED: Record<string, { menuId: string; sub: string }> = {
  adwatch: { menuId: "ads", sub: "adwatch" },
};

export function DiscoverReportPage({ brand, slug }: { brand: Brand; slug?: string }) {
  const moved = slug ? MOVED[slug] : undefined;
  const report = findReport(slug);

  if (moved) return <Navigate to={menuPath(brand.id, moved.menuId, moved.sub)} replace />;
  const blocked = report ? blockedReason(report, brand) : null;

  if (!report || blocked) {
    return (
      <div className="panel empty-state">
        <h3>{report ? report.title : "ไม่พบรายงานนี้"}</h3>
        <p className="muted">{blocked ?? "รายงานที่เรียกมาไม่มีอยู่ในเมนู Discover แล้ว"}</p>
        <Link className="btn-primary inline-btn" to={menuPath(brand.id, "discover")}>
          กลับไป Discover
        </Link>
      </div>
    );
  }

  if (report.inboxPage) {
    return (
      <FbEmbedPage
        brand={brand}
        page={report.inboxPage}
        title={report.title}
        crumb={`Discover / ${report.title}`}
      />
    );
  }

  const url = report.url?.(brand) ?? "";

  return (
    <>
      <EmbedHead
        crumb={`${brand.name} / Discover`}
        title={report.title}
        right={
          <a className="btn-outline inline-btn" href={url} target="_blank" rel="noreferrer">
            เปิดในแท็บใหม่ ↗
          </a>
        }
      />
      <div className="embed-frame">
        <iframe src={url} title={report.title} allow="clipboard-write" />
      </div>
    </>
  );
}
